<template>
  <div>
    <div
      class="relative bgsecondary lg:py-12 md:py-12 lg:pb-6 md:pb-6 lg:px-28 md:px-28 px-5 pt-5 pb-5"
    >
      <el-drawer :visible.sync="isShowCMS" :direction="direction">
        <template slot="title"
          ><h2 class="p-2 text-lg bg-primary text-white">
            Content Management System
          </h2></template
        >
        <CMS
          :selectedId="selectedId"
          :isShowCMS="isShowCMS"
          @closePopup="closePopup2"
        />
      </el-drawer>
      <div
        class="fixed lg:right-8 md:right-8 right-4 lg:bottom-8 md:bottom-8 bottom-4 z-50"
      >
        <div
          class="flex cust-bg-229d04 items-center lg:px-6 md:px-4 px-4 lg:py-4 md:py-4 py-3 rounded-full enquiry cursor-pointer"
          pill
        >
          <a
            aria-label="Find in this site"
            href="https://api.whatsapp.com/send?phone=917888488891"
            target="_blank"
          >
            <div class="flex items-center">
              <img
                src="@/assets/images/about/Vector (4).png"
                class="mr-2 color-white lg:w-7 md:w-7 w-5"
                alt="whatsapp logo"
              />
              <p class="text-white fsize14 sm-fsize12 font-semibold">
                Chat With Us
              </p>
            </div>
          </a>
        </div>
      </div>
      <div class="lg:flex md:flex md:flex-wrap mb-6 container mx-auto">
        <div class="lg:w-1/2 md:w-full lg:pr-20 md:pr-20 lg:mb-0 md:mb-0 mb-8">
          <div class="lg:h-110px md:h-110px">
            <img
              src="https://nexuscluster.blob.core.windows.net/server01/eurobond/Eurobond/home/footerlogo.webp"
              class="lg:w-7/12 md:w-8/12 w-7/12 lg:h-32 object-contain"
              alt="footer-logo"
            />
          </div>
          <p
            id="7369992831"
            class="text-justify text-white fsize14 sm-fsize12 line-h24px py-4 hoverText1"
            v-html="
              pageData
                ? pageData['7369992831']
                : 'Euro Panel Products Limited, a pioneer in the aluminium composite panel industry, has made significant advances since its establishment in 2002. Eurobond, a premium ACP sheet manufacturer, is known for its dependability and trustworthiness. Eurobond, which stands tall with the promise of quality and innovation, has a strong distributor network across the country, prestigious clients, and satisfied consumers everywhere. '
            "
          ></p>
          <!-- Euro Panel Products Limited, a pioneer in the aluminium composite
          panel industry, has made significant advances since its establishment
          in 2002.
          Eurobond, a premium ACP sheet manufacturer, is known for its
          dependability and trustworthiness. Eurobond, which stands tall with
          the promise of quality and innovation, has a strong distributor
          network across the country, prestigious clients, and satisfied
          consumers everywhere. -->
          <div
            class="mt-4 grid lg:grid-cols-3 md:grid-cols-3 grid-cols-2 lg:gap-8 md:gap-4"
          >
            <div>
              <div id="5265456157" class="hoverText1">
                <h2
                  class="font-bold uppercase fsize16 ff-mont text-white sm-fsize14"
                  @click="handleClick('Home')"
                >
                  {{ pageData ? pageData["5265456157"] : "Home" }}
                </h2>
              </div>
              <div class="mt-4">
                <!-- <p
                @click="handleClick('Home')"
                class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
              >
                Home
              </p> -->
                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('Projects')"
                >
                  Projects
                </p>

                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('download-catalogues')"
                >
                  Download Catalogue
                </p>
                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('Investor Relation')"
                >
                  Investor Relations
                </p>
                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('Careers')"
                >
                  Careers
                </p>
                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('Contact')"
                >
                  Contact
                </p>
              </div>
            </div>
            <div>
              <div id="3282292013" class="hoverText1">
                <h2
                  class="font-bold uppercase fsize16 ff-mont text-white sm-fsize14"
                >
                  {{ pageData ? pageData["3282292013"] : "About Us" }}
                </h2>
              </div>
              <div class="mt-4">
                <p
                  @click="handleClick('About Eurobond')"
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                >
                  About Eurobond
                </p>
                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('Our Presence')"
                >
                  Our Presence
                </p>

                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('Key Managerial Personnel')"
                >
                  Key Managerial Personnel
                </p>
                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('Our Manufacturing')"
                >
                  Our Manufacturing
                </p>
                <a href="http://rewards.eurobondacp.com">
                  <p
                    class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  >
                    Eurobond Rewards
                  </p>
                </a>
                <!-- <p
                class="text-828f99 fsize14 mb-2 cursor-pointer"
                @click="handleclick('cancellation-policy')"
              >
                Cancellation Policy
              </p> -->
              </div>
            </div>
            <div>
              <div id="3808271726" class="hoverText1">
                <h2
                  class="font-bold uppercase fsize16 ff-mont text-white sm-fsize14"
                >
                  {{ pageData ? pageData["3808271726"] : "Products" }}
                </h2>
              </div>
              <div class="mt-4">
                <p
                  @click="handleClick('ACP')"
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                >
                  Aluminium Composite Panel
                </p>
                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('AHPL')"
                >
                  Aluminium HPL
                </p>

                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('FR ACP')"
                >
                  Fire Retardant Panels
                </p>
                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('Eurocore')"
                >
                  EUROCORE - Aluminium Core Composite Panels
                </p>
                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleclick('Eurocomb')"
                >
                  EUROCOMB - Aluminium Honeycomb Panels
                </p>
                <p
                  class="text-white fsize14 sm-fsize12 mb-2 cursor-pointer hover"
                  @click="handleClick('ZINC')"
                >
                  Zinc Composite Panel
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="lg:w-1/2 md:w-full lg:pl-20 md:pl-0 w-full cust-reverse pl-0"
        >
          <div class="bg-el-dialog">
            <el-dialog
              width="40%"
              :visible.sync="isMessage"
              ref="isMessage"
              class="custbg-color sm-width-90 contact p0"
            >
              <template slot="title">
                <p class="w-full text-white">Message</p>
              </template>
              <MessagePopup @closeModal="closeModal" />
            </el-dialog>
          </div>
          <div>
            <h4
              id="8507285683"
              class="fsize20 sm-fsize16 font-bold text-white hoverText1"
            >
              {{ pageData ? pageData["8507285683"] : "Contact Us" }}
            </h4>
            <p
              id="2221876274"
              class="text-white fsize14 sm-fsize12 line-h24px my-2 hoverText1"
            >
              {{
                pageData
                  ? pageData["2221876274"]
                  : "  We usually respond before 24 hours."
              }}
            </p>
            <div class="lg:w-10/12 md:w-10/12 mt-2 w-full">
              <el-form ref="ruleForms" :model="ruleForm" :rules="rules">
                <el-form-item prop="name">
                  <el-input id="" placeholder="Name" v-model="ruleForm.name" />
                </el-form-item>
                <el-form-item prop="email">
                  <el-input placeholder="Email" v-model.trim="ruleForm.email" />
                </el-form-item>
                <el-form-item prop="mobile">
                  <el-input
                    placeholder="Mobile"
                    v-model.trim="ruleForm.mobile"
                  />
                </el-form-item>
                <el-form-item prop="message">
                  <el-input placeholder="Message" v-model="ruleForm.message" />
                </el-form-item>
              </el-form>
              <!-- <recaptcha
                class="mt-4"
                ref="reCaptcha"
                @verify="isVerifyCap"
              ></recaptcha> -->

              <div
                class="mt-8 flex justify-center lg:mb-0 md:mb-0 mb-4 hoverText1"
                id="1051537815"
              >
                <vs-button
                  color="primary"
                  @click="handleSubmit('ruleForms')"
                  class="bg-ff9137 w-full border-0 rounded-sm text-white lg:py-3 md:py-4 py-2"
                  >{{ pageData ? pageData["1051537815"] : "Submit" }}</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-top"></div>
      <div id="5906713235" class="lg:flex md:flex justify-center items-center">
        <p class="text-white text-center fsize14 lg:mt-8 md:mt-4 mt-4">
          {{
            pageData
              ? "© 2000-2025, All Rights Reserved"
              : "&copy; 2000-2023, All Rights Reserved make it 2024"
          }}
        </p>
        <div
          class="flex lg:mt-6 md:mt-6 pl-16 mt-2 lg:pb-0 pb-6 place-content-center sm-w75 gap-5"
        >
          <a
            aria-label="icon"
            href="https://instagram.com/eurobond_acp?igshid=YmMyMTA2M2Y="
            target="_blank"
          >
            <feather-icon
              icon="InstagramIcon"
              class="text-white w-10 lg:h-50px lg:p-1 md:p-1 p-1 rounded-full lg:mr-2 md:mr-2 cursor-pointer hover"
          /></a>
          <a
            aria-label="icon"
            href="https://youtube.com/@EurobondMumbai"
            target="_blank"
            ><feather-icon
              icon="YoutubeIcon"
              class="text-white w-10 lg:h-50px lg:p-1 md:p-1 p-1 rounded-full lg:mr-2 md:mr-2 cursor-pointer hover"
          /></a>
          <a
            aria-label="icon"
            href="https://www.linkedin.com/company/eurobond-acp"
            target="_blank"
            ><feather-icon
              icon="LinkedinIcon"
              class="text-white w-10 lg:h-50px lg:p-1 md:p-1 p-1 rounded-full lg:mr-2 md:mr-2 cursor-pointer hover"
          /></a>
          <a
            aria-label="icon"
            href="https://www.facebook.com/eurobondacppanel?mibextid=LQQJ4d"
            target="_blank"
            ><feather-icon
              icon="FacebookIcon"
              class="text-white w-10 lg:h-50px lg:p-1 md:p-1 p-1 rounded-full lg:mr-2 md:mr-2 cursor-pointer hover"
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import {
//   PhoneCallIcon,
//   MailIcon,
//   InstagramIcon,
//   YoutubeIcon,
//   TwitterIcon,
//   FigmaIcon,
//   FacebookIcon,
// } from "vue-feather-icons";

import MessagePopup from "./MessageContact.vue";
import CMS from "../mainScreen1/CMSComponent/CMS";
export default {
  data() {
    return {
      value1: "",
      captcha: false,
      isMessage: false,
      isShowCMS: false,
      pageData: {},
      selectedId: "",
      direction: "rtl",
      ruleForm: {
        name: "",
        mobile: "",
        email: "",
        message: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please enter name",
            trigger: "blur",
          },
          {
            required: true,
            pattern: /^[a-zA-Z]+[\-'\s]?[a-zA-Z]+$/,
            message: "Please enter valid name !",
            trigger: "change",
          },
        ],
        email: [
          {
            required: true,
            message: "Please enter email address!",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter valid email address!",
            trigger: "change",
          },
        ],
        mobile: [
          {
            required: true,
            message: "Please enter mobile number!",
            trigger: "blur",
          },
          {
            min: 10,
            max: 10,
            pattern: /^(\+\d{1,3}[- ]?)?\d{10}$/,
            message: "Please enter valid mobile number!",
            trigger: "change",
          },
        ],
        message: [
          {
            required: true,
            message: "Please type a message!",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    // PhoneCallIcon,
    // MailIcon,
    // InstagramIcon,
    // YoutubeIcon,
    // TwitterIcon,
    // FigmaIcon,
    // FacebookIcon,
    MessagePopup,

    CMS,
  },
  watch: {
    isShowCMS(newValue) {
      // console.log(newValue);
    },
    pages(value) {
      this.pageData = value["Footer"];
    },
  },
  computed: {
    ...mapState("cms", ["pages", "user"]),
  },
  methods: {
    async removeClass() {
      let classData = document.getElementsByClassName("hoverText1");

      const elementsArray = Array.from(classData);

      elementsArray.forEach((element) => {
        element.classList.remove("hoverText1");
      });
    },

    addClass() {
      let classData2 = document.getElementsByClassName("hoverText1");

      let classData = document.getElementsByClassName("hoverText1");
      // console.log(classData, "home");
      for (let i = 0; i < classData.length; i++) {
        classData[i].classList.add("hoverText1");
        if (classData[i]) {
          // console.log(classData[i].id, "ids");
          classData[i].addEventListener("click", () => {
            this.selectedId = classData[i].id;
            // console.log(this.selectedId, "selected");
            this.isShowCMS = true;
          });
        }
      }
    },

    async closePopup2() {
      // console.log("close");
      this.isShowCMS = false;
      let cms = { projectName: process.env.VUE_APP_COMMUNITY_NAME };
      await this.$store.dispatch("cms/getClientCms", cms);
    },
    closeModal() {
      this.isMessage = false;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    isShowAbout() {
      this.$router.push({ name: "our-journey" });
    },
    isShowProduct() {
      this.$router.push({ name: "Product" });
    },
    isShowRelation() {
      this.$router.push({ name: "Investor Relation" });
    },
    isShowConnect() {
      this.$router.push({ name: "contact" });
    },
    isShowCatelogue() {
      this.$router.push({ name: "catelogue" });
    },
    async handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;

        if (valid) {
          this.submitForm();
        } else {
          this.$notify.error({
            message: "Please Enter Valid Entry OR Somthing Went Wrong!",
            position: "bottom-right",
          });
          return false;
        }
      });
    },
    isVerifyCap(res) {
      if (res) {
        this.captcha = true;
      }
    },
    async submitForm() {
      this.sendConversionEvent();
      let payload = {
        name: this.ruleForm.name,
        email: this.ruleForm.email,
        mobile: this.ruleForm.mobile,
        message: this.ruleForm.message,
      };
      if (this.$route.query.hasOwnProperty("utm_campaign")) {
        Object.assign(payload, {
          UTM_Campaign: this.$route.query.utm_campaign,
        });
      } else {
        Object.assign(payload, { UTM_Campaign: "none" });
      }

      if (this.$route.query.hasOwnProperty("utm_medium")) {
        Object.assign(payload, {
          UTM_Medium: this.$route.query.utm_medium,
        });
      } else {
        Object.assign(payload, { UTM_Medium: "none" });
      }

      if (this.$route.query.hasOwnProperty("utm_source")) {
        Object.assign(payload, {
          UTM_Source: this.$route.query.utm_source,
        });
      } else {
        Object.assign(payload, { UTM_Source: "none" });
      }
      try {
        const state = await this.$store.dispatch("admin/ContactUs", payload);
        if (state.code == 200) {
          this.$vs.loading.close();
          // this.$refs.reCaptcha.reset();
          // this.$message({
          //   type: "success",
          //   message:
          //     "Thank you for contacting. Our team will get to you shortly!",
          // });

          this.$refs["ruleForms"].resetFields();
        }
        this.$router.push({ name: "footer/thankyou" });
        this.isMessage = true;
      } catch (error) {
        this.error(error);
        this.$vs.loading.close();
      }
    },
    async sendConversionEvent() {
      const tagScript = document.createElement("script");
      tagScript.innerText = `gtag('event','conversion',{'send_to':'AW-800891346/Yx94CPic2bwYENLD8v0c'})`;
      document.head.appendChild(tagScript);
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
          send_to: "AW-800891346/Yx94CPic2bwYENLD8v0c",
        });
      }
    },
  },

  async mounted() {
    // this.init();
    if (this.pages) {
      this.pageData = this.pages["Footer"];
    }

    if (this.$route.query.token === "123") {
      await this.addClass();
    } else {
      await this.removeClass();
    }
    const script = document.createElement("script");

    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-800891346";

    script.async = true;
    // console.log("Hello");
    // console.log(script);
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];

    function gtag() {
      dataLayer.push(arguments);
    }

    gtag("js", new Date());

    gtag("config", "AW-800891346");

    gtag("event", "conversion", {
      send_to: "AW-800891346/9uySCPrF-KUYENLD8v0C",
    });
  },
};
</script>
<style scoped>
.h-110px {
  height: 110px;
}
</style>
